import {
    TableRow,
    TableCell,
    Checkbox,
    IconButton,
    Avatar,
    makeStyles,
    createStyles
} from "@material-ui/core";
import React, { memo, useEffect, useState } from "react";
import EditProfileImage from "../../common/components/modal/EditProfileImage";
import EditIcon from "@material-ui/icons/Edit";
import styles from "./EditUserTableRow.module.css";
import { Group, UserSkill } from "../../user/User";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { roles } from "../../utils/LogicUtils";

const useStyles = makeStyles(() =>
    createStyles({
        select: {
            width: "100px",
            fontFamily: "noto-sans-cjk-jp !important",
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid rgba(0, 0, 0, 0.87);",
            }
        },
    })
);

interface UserData {
    id: string;
    imageUrl: string;
    imageFile: any;
    fullName: string;
    email: string;
    localAccountId: string;
    organization: string;
    lastLogin: string;
    skills: number[];
    skillList: UserSkill[];
    isAdmin: boolean;
    isEditor: boolean;
    isProf: boolean;
    isGuest: boolean;
    isUnavailable: boolean;
    group: Group[];
    loginIn45days: boolean;
}

interface EditUserTableRowProps {
    userId: number;
    user: UserData;
    ChangeProfileImage: (changeIndex: string, newImageUrl: string, newImageFile: any) => void;
    OpenSkillSelectModal: (openUserId: string, openUserName: string) => void;
    OpenGroupSelectModal: (openUserId: string, openUserName: string) => void;
    ChangeRole: (changeUserId: number, role: string) => void;
    ChangeProf: (changeIndex: number, changeValue: boolean) => void;
    ChangeAvailable: (changeIndex: number, changeValue: boolean) => void;
}

function EditUserTableRow({
    userId,
    user,
    ChangeProfileImage,
    OpenSkillSelectModal,
    OpenGroupSelectModal,
    ChangeRole,
    ChangeProf,
    ChangeAvailable,
}: EditUserTableRowProps) {
    const classes = useStyles();
    const [inputRole, setInputRole] = useState<string>("");

    // 表示用役割
    useEffect(() => {
        const userRole = user.isAdmin ? roles[0] : user.isEditor ? roles[1] : roles[2];
        setInputRole(userRole);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    // ユーザ役割変更
    const handleChangeRole = (event: any) => {
        ChangeRole(userId, event.target.value);
        setInputRole(event.target.value);
    };

    return (
        <TableRow key={userId} style={{ width: "100%" }}>
            {/* <TableCell style={{borderBottom: 0}}><IconButton>
<CancelIcon style={{width:"40px",height:"40px",color:"gray"}} onClick={ () => ClickUserDeleteButton(row.id) }/>
</IconButton></TableCell> */}
            <TableCell style={{ borderBottom: 0, position: "relative" }}>
                <div>
                    <Avatar
                        src={user.imageUrl}
                        variant="circular"
                        style={{
                            height: "55px",
                            width: "55px",
                            backgroundColor: "gainsboro",
                            fontFamily: "noto-sans-cjk-jp",
                        }}
                    />
                    <div className={styles.camera}>
                        <EditProfileImage
                            userid={String(userId)}
                            fullname={user.fullName}
                            organization={user.organization}
                            localAccountId={user.localAccountId}
                            onCallback={ChangeProfileImage}
                        />
                    </div>
                </div>
            </TableCell>
            <TableCell
                align="left"
                style={{
                    borderBottom: 0,
                    fontSize: "10px",
                    textAlign: "left",
                    whiteSpace: "nowrap",
                    fontFamily: "noto-sans-cjk-jp",
                }}
            >
                <div
                    style={{
                        width: "170px",
                        minWidth: "170px",
                        maxWidth: "170px",
                        fontFamily: "noto-sans-cjk-jp",
                    }}
                    className={styles.cellBottomBorder}
                >
                    <h2>{user.fullName}</h2>
                </div>
            </TableCell>
            <TableCell
                align="left"
                style={{
                    borderBottom: 0,
                    fontSize: "10px",
                    textAlign: "left",
                    whiteSpace: "nowrap",
                    fontFamily: "noto-sans-cjk-jp",
                }}
            >
                <div style={{ width: "100%" }} className={styles.cellBottomBorder}>
                    <h2
                        style={{
                            width: "280px",
                            minWidth: "280px",
                            maxWidth: "280px",
                        }}
                    >
                        {user.email}
                    </h2>
                </div>
            </TableCell>
            <TableCell
                align="left"
                style={{
                    borderBottom: 0,
                    fontSize: "10px",
                    textAlign: "left",
                    whiteSpace: "nowrap",
                    fontFamily: "noto-sans-cjk-jp",
                }}
            >
                <div
                    style={{
                        width: "130px",
                        minWidth: "130px",
                        maxWidth: "130px",
                    }}
                    className={styles.cellBottomBorder}
                >
                    <h2>{user.lastLogin}</h2>
                </div>
            </TableCell>
            <TableCell
                align="left"
                style={{
                    borderBottom: 0,
                    fontSize: "10px",
                    textAlign: "left",
                    whiteSpace: "nowrap",
                }}
            >
                <div
                    style={{
                        width: "70px",
                        minWidth: "70px",
                        maxWidth: "70px",
                        display: "flex",
                        fontFamily: "noto-sans-cjk-jp",
                    }}
                    className={styles.cellBottomBorder}
                >
                    <h2>{Object.keys(user.skillList).length}件</h2>
                    <IconButton
                        onClick={() => OpenSkillSelectModal(user.id, user.fullName)}
                        className={styles.skillEditIcon}
                    >
                        <EditIcon
                            style={{
                                width: "20px",
                                height: "20px",
                                color: "var(--main)",
                            }}
                            color="secondary"
                        />
                    </IconButton>
                </div>
            </TableCell>
            <TableCell
                align="left"
                style={{
                    borderBottom: 0,
                    fontSize: "10px",
                    textAlign: "left",
                    whiteSpace: "nowrap",
                }}
            >
                <div
                    style={{
                        width: "70px",
                        minWidth: "70px",
                        maxWidth: "70px",
                        display: "flex",
                        fontFamily: "noto-sans-cjk-jp",
                    }}
                    className={styles.cellBottomBorder}
                >
                    {user.group && <h2>{user.group.length}件</h2>}
                    {!user.group && <h2>0件</h2>}
                    <IconButton
                        onClick={() => OpenGroupSelectModal(user.id, user.fullName)}
                        className={styles.skillEditIcon}
                    >
                        <EditIcon
                            style={{
                                width: "20px",
                                height: "20px",
                                color: "var(--main)",
                            }}
                            color="secondary"
                        />
                    </IconButton>
                </div>
            </TableCell>
            <TableCell align="center" style={{ borderBottom: 0 }}>
                <Select
                    color="secondary"
                    variant="outlined"
                    onChange={handleChangeRole}
                    value={inputRole}
                    className={classes.select}
                >
                    {roles.map((role) => (
                        <MenuItem key={role} value={role}>
                            {role}
                        </MenuItem>
                    ))}
                </Select>
            </TableCell>
            <TableCell align="center" style={{ borderBottom: 0 }}>
                <Checkbox
                    color="default"
                    defaultChecked={user.isProf}
                    onChange={() => ChangeProf(userId, user.isProf)}
                />
            </TableCell>
            <TableCell align="center" style={{ borderBottom: 0 }}>
                <Checkbox
                    color="default"
                    defaultChecked={!user.isUnavailable}
                    onChange={() => ChangeAvailable(userId, user.isUnavailable)}
                />
            </TableCell>
            <TableCell
                align="center"
                style={{
                    borderBottom: 0,
                    fontSize: "10px",
                    textAlign: "left",
                    whiteSpace: "nowrap",
                    fontFamily: "noto-sans-cjk-jp",
                }}
            >
                <div style={{}} className={styles.cellBottomBorder}>
                    {user.loginIn45days && <h2>アクティブ</h2>}
                    {!user.loginIn45days && <h2>非アクティブ</h2>}
                </div>
            </TableCell>
            {/* <TableCell align="center" style={{borderBottom: 0}}><Checkbox color="default" defaultChecked={row.isGuest} onChange={ () => ChangeGuest(userId, row.isGuest) }/></TableCell> */}
        </TableRow>
    );
}
export default memo(EditUserTableRow);
